// @ts-nocheck
/* eslint-disable spire/export-styles */
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { SafeDictionary } from "@insite/client-framework/Common/Types";

import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import { getUnitNetPrice } from "@insite/client-framework/Services/Helpers/ProductPriceService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { canAddToCart, hasEnoughInventory } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import addToCart from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";
import translate from "@insite/client-framework/Translate";
// import { CartLineModel, ProductSubscriptionDto } from "@insite/client-framework/Types/ApiModels"; Valtech Custom Code
import ProductAddedToCartMessage from "@insite/content-library/Components/ProductAddedToCartMessage";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import React, { useContext, useState } from "react";
// import { connect, ResolveThunks } from "react-redux"; // Valtech Custom Code

// Bunzl Custom Code
import StoreVariantsButton from "@store/Library/Components/Foundation/StoreVariantsButton";

// Valtech Custom Code -->
import { useAllowBackOrder } from "@store/Framework/Store/Bunzl/Components/ProductAddToCartButton/ProductAddToCartButtonHooks";
import SignInToSeePriceButton from "@store/Library/Components/Foundation/SignInToSeePriceButton";
import {
    HasProductContext,
    ProductContext,
    withProductContext,
} from "@insite/client-framework/Components/ProductContext";
import { CartLineModel, ProductInventoryDto, ProductSubscriptionDto } from "@insite/client-framework/Types/ApiModels";
import { useIsSignedInAndhasToBeSignedIn } from "@store/Framework/Store/Context/ContextHooks";
import { useAnalytics } from "@store/Framework/Store/Context/ContextHooks";
import useCanAddToCart from "@store/Framework/Store/Data/Products/ProductsHooks/useCanAddToCart";
import {
    useCanAddToCart as toolKitUseCanAddToCart,
    useHasEnoughInventory,
} from "@toolkit/Framework/Store/Data/Products/ProductsHooks";
import { connect, ResolveThunks, useSelector } from "react-redux";
export interface ProductAddToCartButtonProps extends Omit<OwnProps, keyof ButtonPresentationProps> {}
// <-- Valtech Custom Code

export interface OwnProps /* Valtech Custom Code */ {
    labelOverride?: string;
    extendedStyles?: ButtonPresentationProps;
    notes?: string;
    configurationSelection?: SafeDictionary<string>;
    configurationCompleted?: boolean;
    variantSelectionCompleted?: boolean;
    subscription?: ProductSubscriptionDto;
    onAddToCartClick?: () => void;
    variantButtonExtendedStyles?: ButtonPresentationProps; // Bunzl Custom Code
}

export const useShowProductAddToCartButton = (
    configurationCompleted: boolean | undefined,
    variantSelectionCompleted: boolean | undefined,
) => {
    const productContext = useContext(ProductContext);
    const { product, productInfo } = productContext;
    const hasEnoughInventory = useHasEnoughInventory(productContext);
    const canAddToCart = toolKitUseCanAddToCart(
        product,
        productInfo,
        configurationCompleted,
        variantSelectionCompleted,
    );

    return !((!hasEnoughInventory && !productInfo.failedToLoadInventory) || !canAddToCart);
};
// Valtech Custom Code -->
export interface CustomProductInventoryDto extends ProductInventoryDto {
    preventAddToCart: boolean;
}
// <-- Valtech Custom Code

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasProductContext;

const mapStateToProps = (state: ApplicationState, props: OwnProps & HasProductContext) => {
    const {
        productSettings, // Valtech Custom Code
        cartSettings: { addToCartPopupTimeout },
    } = getSettingsCollection(state);
    return {
        canAddToCart: canAddToCart(
            state,
            props.productContext.product,
            props.productContext.productInfo,
            props.configurationCompleted,
            props.variantSelectionCompleted,
        ),
        hasEnoughInventory: hasEnoughInventory(state, props.productContext),
        isUpdatingCart: state.context.isUpdatingCart,
        showAddToCartConfirmationDialog: productSettings.showAddToCartConfirmationDialog, // Valtech Custom Code
        addToCartPopupTimeout,
        // Valtech Custom Code
        productSettings,
        currentCurency: state.context.session.currency?.currencyCode,
    };
};

const mapDispatchToProps = {
    addToCart: makeHandlerChainAwaitable<Parameters<typeof addToCart>[0], CartLineModel>(addToCart),
};

export const productAddToCartButtonStyles: ButtonPresentationProps = {};

const ProductAddToCartButton = ({
    productContext: {
        product, // Valtech Custom Code
        productInfo, // Valtech Custom Code
    },
    onAddToCartClick,
    hasEnoughInventory,
    isUpdatingCart,
    showAddToCartConfirmationDialog,
    addToCartPopupTimeout,
    addToCart,
    // canAddToCart, // Valtech Custom Code
    labelOverride,
    extendedStyles,
    notes,
    configurationSelection,
    configurationCompleted,
    variantSelectionCompleted,
    subscription,
    // Valtech Custom Code --->
    productContext,
    currentCurency,
    productSettings,
    // <--- Valtech Custom Code
    variantButtonExtendedStyles, // Bunzl Custom Code
    ...otherProps
}: Props) => {
    const toasterContext = useContext(ToasterContext);
    const [styles] = useState(() => mergeToNew(productAddToCartButtonStyles, extendedStyles));

    // Valtech Custom Code --->
    const { dispatchAddToCartEvent } = useAnalytics();
    const preventAddToCart = (productInfo?.inventory as CustomProductInventoryDto)?.preventAddToCart ?? false;
    const isSignedInAndhasToBeSignedIn = useIsSignedInAndhasToBeSignedIn();
    const allowBackOrder = useAllowBackOrder();
    const productCanAddToCart = useCanAddToCart(
        product,
        productSettings,
        productInfo,
        hasEnoughInventory,
        configurationCompleted,
        variantSelectionCompleted,
        allowBackOrder,
    );

    const canAddToCart = !preventAddToCart && productCanAddToCart;

    if (!isSignedInAndhasToBeSignedIn) {
        return <SignInToSeePriceButton {...styles} />;
    }

    if (product.isVariantParent) {
        // Bunzl Custom Code
        return (
            <StoreVariantsButton extendedStyles={variantButtonExtendedStyles} path={productInfo.productDetailPath} />
        );
    }
    // <-- Valtech Custom Code
    const addToCartClickHandler = async () => {
        if (!canAddToCart /* Valtech Custom Code */) {
            toasterContext.addToast({ body: siteMessage("Cart_InvalidPrice"), messageType: "danger" });
            return;
        }
        // bunzl readded code
        onAddToCartClick?.();
        const sectionOptions =
            configurationSelection && Object.values(configurationSelection).length > 0
                ? Object.values(configurationSelection)
                      .filter(sectionOptionId => !!sectionOptionId)
                      .map(sectionOptionId => ({ sectionOptionId }))
                : undefined;
        const cartline = (await addToCart({
            // Valtech Custom Code
            productId: product.id,
            qtyOrdered: productInfo.qtyOrdered,
            unitOfMeasure: productInfo.unitOfMeasure,
            // Valtech Custom Code
            notes,
            sectionOptions,
            subscription,
        })) as CartLineModel;

        if (showAddToCartConfirmationDialog) {
            toasterContext.addToast({
                body: <ProductAddedToCartMessage isQtyAdjusted={cartline.isQtyAdjusted} multipleProducts={false} />,
                messageType: "success",
                timeoutLength: cartline.isQtyAdjusted ? 1000 * 60 * 60 * 24 * 365 : addToCartPopupTimeout,
            });
            dispatchAddToCartEvent(productContext, currentCurency); // Valtech Custom Code
        }
    };

    return (
        <Button
            {...styles}
            onClick={addToCartClickHandler}
            disabled={productInfo.qtyOrdered <= 0 || isUpdatingCart || !canAddToCart /* Valtech Custom Code */}
            {...otherProps}
        >
            {labelOverride ?? translate("Add to Cart")}
        </Button>
    );
};
export default withProductContext(connect(mapStateToProps, mapDispatchToProps)(ProductAddToCartButton));
